import { useGlobalContext } from "../../context";

const UserImage = ({ note }) => {
  const { color5 } = useGlobalContext();

  const handleImageError = (e) => {
    e.target.src = `https://avatar.oxro.io/avatar.svg?name=${note.TechnicianName}&background=4D6AEF&length=2`;
  };
  const getMediaStorageUrl = (input) => {
        if (!input || typeof input !== "string") return null;

  const urls = input
    .split("https://")
    .filter(Boolean) // elimina strings vacíos
    .map(part => "https://" + part);

  const mediaStorageUrl = urls.find(url => url.includes("media-storage.helppeoplecloud.com"));
  return mediaStorageUrl || null;
}

 
  return (
    <div className="flex relative h-11 w-11 justify-self-end">
      <img
        className={`rounded-full border-4 ${note.UserIsVIP === "1" || note.TechnicianIsVIP === "1"
          ? `border-${color5}`
          : "border-white"
          } bg-white w-11 h-11`}
        src={
          getMediaStorageUrl(note.UserImage) !== null
            ? getMediaStorageUrl(note.UserImage)
            : `https://avatar.oxro.io/avatar.svg?name=administrador&background=4D6AEF&length=2`
        }
        alt="profile"
        onError={handleImageError} />
      {(note.UserIsVIP === "1" || note.TechnicianIsVIP === "1") && (
        <div className="absolute bottom-0 right-0 h-4 w-4 rounded-full bg-yellow-400 flex justify-center items-center p-1">
          (
          <svg
            className="fill-current h-3"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.002 512.002"
          >
            <path d="M511.267 197.258a14.995 14.995 0 00-12.107-10.209l-158.723-23.065-70.985-143.827a14.998 14.998 0 00-26.901 0l-70.988 143.827-158.72 23.065a14.998 14.998 0 00-8.312 25.585l114.848 111.954-27.108 158.083a14.999 14.999 0 0021.763 15.812l141.967-74.638 141.961 74.637a15 15 0 0021.766-15.813l-27.117-158.081 114.861-111.955a14.994 14.994 0 003.795-15.375z" />
          </svg>
          )
        </div>
      )}
    </div>
  );
};

export default UserImage;
